import { Component, OnInit, Input, ViewChild, ChangeDetectionStrategy, ComponentRef, ElementRef } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';

@Component({
  selector: 'app-row-focus-box',
  templateUrl: './row-focus-box.component.html',
  styleUrls: ['./row-focus-box.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,

})
export class RowFocusBoxComponent implements OnInit {
  scroll:HTMLElement;
  @ViewChild('content') content:ElementRef;
  @Input('scrollContainer') scrollContainerQuery:string|ComponentRef<any>|HTMLElement = 'table';  
  private _y:number = 0;
  @Input() set y (new_v:number) {
    const old_v = this._y;
    if (old_v !== new_v) {
      this._y = new_v;
      if (this.scrollContainer) this.resizeHeight();
    }
  }
  get y ():number {
    return this._y;
  }
  @Input() childHeight:number = 42;
  @Input() index:number = 3;
  private scrollContainer:HTMLElement;  
  private scrollTop:number = 0;
  refreshScrollTop () {
    const new_v = this.scrollContainer.scrollTop;
    const old_v = this.scrollTop;
    if (old_v !== new_v) {
      this.scrollTop = new_v;
      this.scroll.scrollTop = new_v;
    }
    
  }
  private subscription = new Subscription();
  constructor(
    private elRef:ElementRef,
  ) { 
  }

  ngOnInit() {
    const host:Element = this.elRef.nativeElement;
    this.scroll = host.querySelector('#scroll');

  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }

  private setScrollContainer() {
    const contentDiv:HTMLDivElement = this.content.nativeElement;
    if (typeof this.scrollContainerQuery === 'string') this.scrollContainer = contentDiv.parentElement.querySelector(this.scrollContainerQuery);
    else if (this.scrollContainerQuery instanceof ComponentRef) this.scrollContainer = this.scrollContainerQuery.location.nativeElement;
    else this.scrollContainer = this.scrollContainerQuery;
  };
  private watchScroll () {
    this.subscription.add(fromEvent(this.scrollContainer, 'scroll').subscribe(()=>{
      this.refreshScrollTop();
    }));
  }
  private resizeHeight () {
    const height = this.elRef.nativeElement.querySelector('#height-dummy');
    // DO NOT trust virtual scroller's scrollHeight :
    // virtual scroller's scrollHeight ONLY include #container element's height.
    // `${this.scrollContainer.scrollHeight}px`;
    (<HTMLDivElement>height).style.height = `${this.childHeight * (this.y)}px`; 
    // (<HTMLDivElement>height).style.height = `${this.scrollContainer.offsetHeight}px`; 
    // this.scroll.scrollTop = 3;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.scrollContainerQuery) return console.error('scrollContainerQuery is not provided');
      this.setScrollContainer();
      this.resizeHeight();
      this.watchScroll();
    });
  }  
}
